export const FLOW_TOKENS = {
  node: {
    width: 100,
    height: 40,
    decisionSize: 80,
    refRadius: 42,
  },
  color: {
    nodeFill: '#F0F2F5',
    nodeStroke: '#B0B8C4',
    nodeStrokeSelected: '#33BCE1',
    navy: '#1F3864',
    navyDark: '#152744',
    navyText: '#FFFFFF',
    textPrimary: '#1A202C',
    textSecondary: '#4A5568',
    textTertiary: '#8C94A0',
    connector: '#5A6A7A',
    connectorLabel: '#4A5568',
    surface: '#FFFFFF',
    surfaceAlt: '#F4F5F7',
    surfaceSubtle: '#F8FAFC',
    border: '#D9DDE3',
    borderStrong: '#94A3B8',
    secondary: '#33BCE1',
    statusApproved: '#16A34A',
    statusPending: '#F59E0B',
    statusRejected: '#DC2626',
    statusDraft: '#9CA3AF',
  },
  font: {
    family: "'Montserrat', sans-serif",
    nodeTitle: { size: '7.2px', weight: 600 },
    nodeDesc: { size: '8.1px', weight: 400 },
    connectorLabel: { size: '8px', weight: 600 },
    laneHeader: { size: '6.5px', weight: 700, letterSpacing: '0.6px' },
    phaseLabel: { size: '6px', weight: 600 },
    metadata: { size: '8px', weight: 500 },
  },
  shape: {
    borderRadius: 3,
    borderRadiusStart: 10,
    borderRadiusEnd: 12,
    borderRadiusResult: 10,
    strokeWidth: 0.8,
    strokeWidthSelected: 1.4,
    strokeWidthNavy: 0.8,
    shadow: '0 0.5px 0.8px rgba(0,0,0,0.06)',
  },
  connector: {
    width: 1,
    cornerRadius: 10,
    arrowSize: { w: 5.5, h: 4.5 },
    labelBg: '#FFFFFF',
    labelBorder: '#D9DDE3',
    labelBorderWidth: 0.3,
    labelPadding: { h: 8, v: 6 },
    labelRadius: 2,
  },
  canvas: {
    a3Width: 1500,
    a3Height: 780,
    snapGrid: 10,
    sheetBorder: 'rgba(180,195,215,0.45)',
    outsideBg: '#F0F2F7',
  },
  spacing: {
    grid: 10,
    nodeGap: 40,
    laneGap: 48,
    canvasMargin: 24,
  },
  swimlane: {
    headerHeight: 18,
    headerFill: '#1F3864',
    headerText: '#FFFFFF',
    dividerColor: '#D9DDE3',
    dividerWidth: 0.5,
    altBackground: '#F4F5F7',
  },
} as const;

export type FlowTokens = typeof FLOW_TOKENS;
